// eslint-disable-next-line strict
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const ApplicationConfig = {
    mongo: {
        serialized: true,
        idKey: 'id'
    },
    socialLinks: {
      facebook: 'https://www.facebook.com/SpookyTechRiot',
      instagram: 'https://www.instagram.com/spooky_bytes/',
      youtube: 'https://www.youtube.com/channel/UCDb3EZQnwQV6pHbr592Cfxw',
      github: 'https://github.com/Pablo251',
      telegram: 'https://t.me/arce_jp',
      mastodon: 'https://techhub.social/@spooky_bytes'
    },
    tagClasses: {
      post: 'tag',
      news: 'tag secondary',
      tutorial: 'tag tertiary',
    },
    appState: {
      // Change this to true or false when setting the application under maintenance,
      // then create a commit to production and it should be fine.
      // 2026: Let's base this on a env variable and default to false.
      isUnderMaintenance: process.env.REACT_APP_UNDER_MAINTENANCE === 'true' ? true : false,
    }
}

exports["default"] = ApplicationConfig;
module.exports = exports["default"];